import { render, staticRenderFns } from "./DemoDialog.vue?vue&type=template&id=6828ea22&scoped=true&"
import script from "./DemoDialog.vue?vue&type=script&lang=js&"
export * from "./DemoDialog.vue?vue&type=script&lang=js&"
import style0 from "./DemoDialog.vue?vue&type=style&index=0&id=6828ea22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6828ea22",
  null
  
)

export default component.exports